import { createSelector } from "reselect";
import { getSizotsaFuneralCover } from "./index";

export const getBankingDetails = createSelector(
    getSizotsaFuneralCover,
    (sizotsaFuneralCover) => sizotsaFuneralCover.bankingDetails
);
export const getBankingDetailsForm = createSelector(
    getBankingDetails,
    (bankingDetails) => bankingDetails.form
);

const inputFieldLabels = {
    bankName: 'Bank Name',
    branchCode: 'Bank Branch',
    accountHolder: 'Account Holder Name',
    accountNumber: 'Account Number',
    accountType: 'Account Type',
    debitOrderDay: ' Debit Order Deduction Day',
    paymentFrequency:'Payment Frequency'
};
export const getBankingDetailsSummary = createSelector(
    getBankingDetailsForm,
    (bankinDetailsForm) => {
        return Object.keys(bankinDetailsForm).flatMap((item) => {
            return {
                label: inputFieldLabels[item],
                value: bankinDetailsForm[item]?.displayValue ?? '-',
            };
        }).filter(({label})=>label);
    }
);

export const getReferenceDataBank=()=>(
   { paymentMethod:[
        {code: 'Monthly', description: 'Monthly'},
        {code: 'Yearly', description: 'Yearly'},
        
    ]}
  )

export const getPaymentFrequency = createSelector(getBankingDetailsForm,({paymentFrequency})=>paymentFrequency?.value)